import { createStore } from 'vuex'

import version from '@/modules/version/store'
import role from '@/modules/role/store'
import menu from '@/modules/menu/store'
import business from '@/modules/business/store'
import msgauditApply from '@/modules/msgauditApply/store'
import packages from '@/modules/packages/store'

export default createStore({
    // 存放状态
    state: {
        userInfo: {},
        title: '',
        routerPathList: [],
    },
    mutations: {
        // 设置用户信息
        setUserInfo(state, value) {
            state.userInfo = value
        },
        // 设置功能标题
        setTopBarTitle(state, value) {
            state.title = value
        },
        // 设置当前的menuId
        setRouterPaths(state, value) {
            state.routerPathList = value
        },
    },
    getters: {
        userInfoGetter(state) {
            return state.userInfo
        },
    },
    actions: {},
    modules: {
        version,
        packages,
        role,
        menu,
        business,
        msgauditApply,
    },
})
